import React from 'react'
import styled, { css, withTheme } from 'styled-components'

import Container from './Container'
import Title from './Title'
import Button from './Button'

import config from '../config'
import { buildCTA } from '../utils'

const Section = styled.section`
  background: ${config.colors.gray};
  padding: 164px 0 54px 0;

  ${props =>
    props.theme.name === 'green' &&
    css`
      color: #fff;
      background-color: ${config.colors.blue};
    `}

  ${props =>
    props.theme.name === 'blue' &&
    css`
      color: #fff;
      background-color: ${config.colors.lightblue};
    `}

  ${props =>
    props.theme.name === 'platinum' &&
    css`
      background: #888b8d;
      color: #fff;

      h1 {
        color: inherit;
      }
    `}

  ${props =>
    props.theme.name === 'payback' &&
    css`
      background: ${config.colors.peacockBlue};
      color: #fff;

      h1 {
        color: inherit;
      }
    `}

  @media (max-width: 580px) {
    padding-top: 120px;
    padding-bottom: 27px;
  }
`

const Content = styled.div`
  display: flex;
  margin-bottom: 54px;

  @media (max-width: 1080px) {
    flex-wrap: wrap;
  }

  @media (max-width: 860px) {
    flex-direction: column;
  }

  @media (max-width: 480px) {
    margin-bottom: 40px;
  }
`

const Main = styled.div`
  /* width: 60%; */
  flex-basis: 60%;
  ${props =>
    props.theme.name === 'blue' &&
    css`
      flex-basis: 66.5%;
    `}

  @media (max-width: 860px) {
    flex-basis: auto;
    max-width: 100%;
  }
`

const Meta = styled.div`
  flex-basis: 40%;
  padding-right: 30px;
  margin-bottom: 40px;

  ${props =>
    (props.theme.name === 'green' || props.theme.name === 'blue') &&
    css`
      flex-basis: 33.5%;
      & > * {
        color: #fff;
      }
    `}
`

const Action = styled.div`
  margin-bottom: 14px;
  text-align: center;

  @media (max-width: 480px) {
    margin-bottom: 40px;
  }
`

const Features = ({ children, title, theme, variant }) => (
  <Container wide noPadding>
    <Section>
      <Container>
        <Content>
          <Meta>
            <Title>{title}</Title>
          </Meta>
          <Main>{children}</Main>
        </Content>
        <Action>
          <Button
            href={buildCTA(variant)}
            negative={theme.name === 'green' || theme.name === 'blue'}>
            Jetzt beantragen
          </Button>
        </Action>
      </Container>
    </Section>
  </Container>
)

export default withTheme(Features)
